
export const ERROR_NOTHING_TO_MINE = 1;
export const ERROR_HEX_UNCLAIMED=2;
    export const ERROR_ALREADY_DISCOVERED=3;
    export const ERROR_NEED_SURROUND=4;
    export const ERROR_BANNED=5;
    export const ERROR_LACK_OF_ENERGY=101;
    export const ERROR_LACK_OF_MATERIA=102;
    export const ERROR_LACK_OF_COINS=103;
    export const ERROR_INSUFFICIENT_LEVEL=201;
